// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__OMNbv","itemTitle":"ClientEmergencyInfo_itemTitle__zd5x5","itemText":"ClientEmergencyInfo_itemText__3znEy"};